import { Models } from "@hex-insights/app-modules";
import { toOrdinal } from "@hex-insights/core";
import { BuildingFloor } from "../../../Utilities";

// Note: the functions defined in this file can be passed to model field components for consistent formatting.

/**
 * Formats the level field of the BuildingFloor model.
 */
export function level(value: BuildingFloor["level"] | null): string {
	if (value === null) {
		return Models.toString(value);
	}

	if (value === 0) {
		return "Ground Floor";
	}
	return `${toOrdinal(value)} Floor`;
}
